import { BreadcrumbV2Item } from "@/components/interactive/BreadcrumbsV2";
import { ProjectTopRailV2 } from "@/components/navigation/ProjectTopRailV2";
import { useTeamNavbarLinks } from "@/components/navigation/useTeamNavbarLinks";
import React, { useMemo } from "react";

export interface TeamTopRailV2Props {
  activePage?: string;
  className?: string;
  /** Leads the breadcrumbs, as the category nav's sidebar toggle does. */
  leadingAccessory?: React.ReactNode;
}

export const TeamTopRailV2: React.FC<TeamTopRailV2Props> = ({
  activePage,
  className,
  leadingAccessory,
}) => {
  const teamNavbarLinks = useTeamNavbarLinks();
  const activeLink = teamNavbarLinks.find((link) => link.id === activePage);
  const breadcrumbs = useMemo<BreadcrumbV2Item[]>(() => {
    if (activeLink == null) {
      return [{ id: "global-settings", label: "Global settings", nonInteractive: true }];
    }

    return [
      { id: "global-settings", label: "Global settings", nonInteractive: true },
      {
        id: activeLink.id,
        label: activeLink.text,
        current: true,
      },
    ];
  }, [activeLink]);

  return (
    <ProjectTopRailV2
      breadcrumbItems={breadcrumbs}
      className={className}
      leadingAccessory={leadingAccessory}
    />
  );
};
